$(function() {
  return $(document).on('change', '.avatar', function() {
    var file, urlImg
    file = document.querySelector('.avatar').files[0]
    urlImg = URL.createObjectURL(file)
    return $('#btn-img-file').css("background-image", 'url("' + urlImg + '")')
  })
})